export default {
  watch: {
    '$route.params.tipoQuadro': {
      handler (novoTipo, antigoTipo) {
        if (novoTipo !== antigoTipo) {
          this.onLoad()
        }
      },
      immediate: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins/watchTipoQuadroMixin.js